namespace TabAurous {
    export interface ECommInvoicePrintRequest extends Serenity.ServiceRequest {
        Invoice?: TabAurous.ECommerce.ECommSalesRow;
    }
}
